import { shallowEqual, useSelector } from 'react-redux';

import { selectBackOfficeEnterprisesAsArray } from './selectors';

export const useBackOfficeEnterprises = () =>
  useSelector(selectBackOfficeEnterprisesAsArray, shallowEqual);
